import React, { useState, useEffect, useContext } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Grid,
  TextField,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import { Autocomplete } from '@material-ui/lab';

import { Modal, Row, Col } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  formControl: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    minWidth: 200,
    maxWidth: '100%',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function BoxPlanoModal(props) {
  const classes = useStyles();

  const { setBoxes, boxes, data, prods, ...rest } = props;

  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    console.log('props.show', props.show);
    if (props.show) {
      console.log('data', data?.row);
      setSelectedItem(data?.type);
    }
  }, [data]);

  const handleItemChange = (event) => {
    // if (event.target.value === '2') {
    //   // find the above and below boxes
    //   console.log(' boxes.floors', boxes.floors);
    //   console.log('data.row', data.row);
    //   if (data.row - 2 >= 0) {
    //     let above = boxes.floors[data.row - 2];
    //     let below = boxes.floors[data.row];
    //     if (above.lines[data.column - 1].type !== '1') {
    //       return Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: 'You can not link this box, please start link the above box!',
    //       });
    //     } else {
    //       above.lines[data.column - 1].linkArray.push(data.id);
    //       data.linkArray.push(above.lines[data.column - 1].id);
    //     }
    //   } else {
    //     return Swal.fire({
    //       icon: 'error',
    //       title: 'Oops...',
    //       text: 'You can not link this box!',
    //     });
    //   }
    // }
    data.linkArray = [];
    if (selectedItem === '1' && event.target.value === '0') {
      let below = boxes.floors[data.row];
      below.lines[data.column - 1].type = '0';
    }
    if (selectedItem === '2' && event.target.value === '0') {
      let below = boxes.floors[data.row];
      below.lines[data.column - 1].type = '0';
      let below2 = boxes.floors[data.row + 1];
      below2.lines[data.column - 1].type = '0';
    }

    if (event.target.value === '1') {
      //check below box
      let below = boxes.floors[data.row];
      if (below.lines[data.column - 1].type !== '0') {
        return Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Below box is already linked!',
        });
      } else {
        data.linkArray.push(below.lines[data.column - 1].id);
        below.lines[data.column - 1].type = '3';
        below.lines[data.column - 1].product = null;
      }
    }
    if (event.target.value === '2') {
      let below = boxes.floors[data.row];
      if (below.lines[data.column - 1].type !== '0') {
        return Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Below box is already linked!',
        });
      } else {
        below.lines[data.column - 1].type = '3';
        below.lines[data.column - 1].product = null;
        data.linkArray.push(below.lines[data.column - 1].id);
        let below2 = boxes.floors[data.row + 1];
        below2.lines[data.column - 1].type = '3';
        below2.lines[data.column - 1].product = null;
        data.linkArray.push(below2.lines[data.column - 1].id);
      }
    }

    data.type = event.target.value;
    setSelectedItem(event.target.value);

    // setBoxes({ ...boxes });
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Configuration</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body" onClick={() => {}}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {/* <FormControl component="fieldset">
              <FormControl component="fieldset"></FormControl>
              <FormLabel component="legend">Select an item:</FormLabel>
              <RadioGroup
                aria-label="item"
                name="item"
                style={{ flexDirection: 'row' }}
                value={selectedItem}
                onChange={handleItemChange}
              >
                <FormControlLabel
                  value="0"
                  control={<Radio />}
                  label="Normal"
                  disabled={selectedItem === '3'}
                />
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Link 1"
                  disabled={selectedItem === '3'}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Link 2"
                  disabled={selectedItem === '3'}
                />
                <FormControlLabel value="3" control={<Radio />} label="Linked" disabled />
              </RadioGroup>
            </FormControl> */}
            <Grid item xs={12}>
              <Autocomplete
                disabled={selectedItem === '3'}
                options={prods}
                value={data?.product}
                getOptionLabel={(option) => option?.name}
                getOptionSelected={(option, value) => option?._id === value?._id}
                renderInput={(params) => (
                  <TextField {...params} label="Select a product" variant="outlined" fullWidth />
                )}
                onChange={(e, value) => {
                  console.log(value);
                  data.product = value;
                  setBoxes({ ...boxes });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Modal.Body>
    </Modal>
  );
}
